// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application[data-v-439794af] .v-application--wrap{min-height:auto}", ""]);
// Exports
module.exports = exports;
